import { render } from "./InteractiveReadingModule.vue?vue&type=template&id=5b6e2b0c&scoped=true"
import script from "./InteractiveReadingModule.vue?vue&type=script&lang=js"
export * from "./InteractiveReadingModule.vue?vue&type=script&lang=js"

import "./InteractiveReadingModule.vue?vue&type=style&index=0&id=5b6e2b0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6e2b0c"]])

export default __exports__